import { useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CustomCursor from "./components/feature/CustomCursor";
import IntroAnimation from "./components/feature/IntroAnimation";
import MobileContactButton from "./components/feature/MobileContactButton";
import Home from "./pages/home/page";
import { CursorProvider } from "./context/CursorContext";

const KNOWN_ROUTES = ["/", "/contact"];

function AppContent() {
  const [introComplete, setIntroComplete] = useState(false);
  const [introFading, setIntroFading] = useState(false);
  const location = useLocation();
  const isKnownRoute = KNOWN_ROUTES.includes(location.pathname);

  return (
    <>
      <CustomCursor />
      <MobileContactButton />
      {!introComplete && (
        <IntroAnimation
          onComplete={() => setIntroComplete(true)}
          onFadeStart={() => setIntroFading(true)}
        />
      )}
      {isKnownRoute && <Home introComplete={introFading} />}
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CursorProvider>
          <AppContent />
        </CursorProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
